// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np[data-v-33fe4efa] {\n  font-size: 0.8rem;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
